import documentHandlers from './documents';

export const handlers = [...documentHandlers];
